import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";

const HEADER_SELECTOR = "header.header-area";
const openShells = [];
let overflowBeforeShells = "";

export const isOverlayShellOpen = () => openShells.length > 0;

const readHeaderBottom = () => {
  const header = document.querySelector(HEADER_SELECTOR);
  return header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
};

export const useOverlayShell = ({ onClose, closeRef }) => {
  const [container] = useState(() => document.createElement("div"));
  const [top, setTop] = useState(readHeaderBottom);
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;
  const close = useCallback(() => onCloseRef.current(), []);

  useLayoutEffect(() => {
    document.body.prepend(container);
    return () => container.remove();
  }, [container]);

  useLayoutEffect(() => {
    const update = () => setTop(readHeaderBottom());
    update();
    const header = document.querySelector(HEADER_SELECTOR);
    const observer = header && typeof ResizeObserver !== "undefined" ? new ResizeObserver(update) : null;
    observer?.observe(header);
    window.addEventListener("resize", update);
    return () => {
      observer?.disconnect();
      window.removeEventListener("resize", update);
    };
  }, []);

  useEffect(() => {
    const previousTitle = document.title;
    const previousFocus = document.activeElement;
    if (openShells.length === 0) overflowBeforeShells = document.body.style.overflow;
    openShells.push(container);
    document.body.style.overflow = "hidden";
    closeRef.current?.focus({ preventScroll: true });

    const handleKeyDown = (event) => {
      if (event.key === "Escape" && openShells[openShells.length - 1] === container) onCloseRef.current();
    };
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      openShells.splice(openShells.indexOf(container), 1);
      document.removeEventListener("keydown", handleKeyDown);
      if (openShells.length === 0) document.body.style.overflow = overflowBeforeShells;
      document.title = previousTitle;
      if (previousFocus && document.contains(previousFocus)) previousFocus.focus({ preventScroll: true });
    };
  }, [container]);

  return { container, top, close };
};
